import { Component, OnInit } from '@angular/core';
import { VendorSettingsService } from '../vendor-settings.service';
import { ExtendedVendorSettings, IVendorSettings } from './vendor-settings-types';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {
  public settings: IVendorSettings;
  settingsLoaded: boolean = false;
  isBusySaving: boolean = false;
  help: object = {
    lockoutInfo: "When a student is locked out of an exam for exceeding the max number of attempts (per exam settings for an exam in a module), the system sends the student an email telling them who they can contact to get their exam reset and this includes a list of email addresses of users who have the ability to re-set the exam for that student (i.e.: Manager of the Student Group that the Student is in, LC Registrar or their assigned Coach).<br><br>This feature enables you to remove specific email address(es) from that email so the student will not ask them to re-set the exam."
  };

  constructor(private vendorSettingsService: VendorSettingsService, private toast: ToastService, ) {

  }

  reloadSettings(settings: IVendorSettings) {
    this.settings = settings;
    if (this.settings.VendorSettings.token_request_vendor_email == null) {
      this.settings.VendorSettings.token_request_vendor_email = '';
    }

    // Convert encoded JSON

    if (typeof this.settings.VendorSettings.examLockoutNotificationExclusion == "string"){
      this.settings.VendorSettings.examLockoutNotificationExclusion = JSON.parse(this.settings.VendorSettings.examLockoutNotificationExclusion)
    }

   // this.settings.VendorSettings.examLockoutNotificationExclusion = this.settings.VendorSettings.examLockoutNotificationExclusion ? JSON.parse(this.settings.VendorSettings.examLockoutNotificationExclusion) : {};

    if (typeof(this.settings.VendorSettings.examLockoutNotificationExclusion['instructor']) == "undefined") this.settings.VendorSettings.examLockoutNotificationExclusion['instructor'] = false;
    if (typeof(this.settings.VendorSettings.examLockoutNotificationExclusion['manager']) == "undefined") this.settings.VendorSettings.examLockoutNotificationExclusion['manager'] = false;
    if (typeof(this.settings.VendorSettings.examLockoutNotificationExclusion['registrar']) == "undefined") this.settings.VendorSettings.examLockoutNotificationExclusion['registrar'] = false;

    const parsedVendorJsonSettings = JSON.parse(this.settings.VendorSettings.settings as string) as ExtendedVendorSettings;
    if (typeof parsedVendorJsonSettings.vendorIndexHideLcsUntilSearch === 'undefined') {
      parsedVendorJsonSettings.vendorIndexHideLcsUntilSearch = false;
    }
    this.settings.VendorSettings.settings = parsedVendorJsonSettings;
    this.settingsLoaded = true;
  }

  getSettings() {
    this.vendorSettingsService.getSettings().subscribe(settings => this.reloadSettings(settings));
  }

  saveSettings() {
    this.isBusySaving = true;

    let settingsData = JSON.parse(JSON.stringify(this.settings));

    // Re-encode JSON settings
    settingsData.VendorSettings.examLockoutNotificationExclusion = JSON.stringify(this.settings.VendorSettings.examLockoutNotificationExclusion);
    const vs = settingsData.VendorSettings.settings;
    if (typeof vs === 'object' && vs !== null) {
      (vs as ExtendedVendorSettings).vendorIndexHideLcsUntilSearch = !!(vs as ExtendedVendorSettings).vendorIndexHideLcsUntilSearch;
    }
    settingsData.VendorSettings.settings = JSON.stringify(settingsData.VendorSettings.settings);

    this.vendorSettingsService.saveSettings(settingsData).subscribe(
      () => {
        this.isBusySaving = false;
        this.toast.info('Saved vendor settings', 'Success', {
          positionClass: 'md-toast-top-center',
          toastClass: 'opaque',
        });
      },
      error => {
        this.isBusySaving = false;
        this.toast.error(error, 'Error', {positionClass: 'md-toast-top-center', toastClass: 'opaque'});
      }
    );
  }

  ngOnInit() {
    this.getSettings();
  }
}
